import { Controller } from 'stimulus';
import gtag from '../tracking/gtag';
import delegatedEventListener from '../helpers/delegatedEventListener';
import toArray from '../helpers/toArray';

class GuideController extends Controller {
  connect() {
    delegatedEventListener('click', 'a', document, (e) => {
      if (e.target.matches('a[href^="/keuzehulp"]')) {
        e.preventDefault();
        this.openGuide();
      }
    });

    delegatedEventListener('click', '[data-product-rent-button]', this.resultsOutputTarget, (e) => {
      const { productTitle } = e.target.dataset;

      if (!productTitle) return;

      gtag.event('Keuzehulp', 'Product gekozen', productTitle);
    });
  }

  onAnswerChange({ currentTarget }) {
    const currentStep = currentTarget.closest('[data-target="guide.step"]');
    let nextStep = currentStep.nextElementSibling;
    const skipNextQuestion = typeof currentTarget.dataset.skipNextQuestion !== 'undefined'
      && currentTarget.dataset.skipNextQuestion;

    this.completeCurrentStep(currentStep);

    if (!nextStep) {
      this.shootAnswersToAnalytics();
      this.fetchResults();
      return;
    }

    if (skipNextQuestion) {
      this.clearSkippedStep(nextStep);

      nextStep = nextStep.nextElementSibling;
    }

    this.activateNextStep(nextStep);
  }

  // eslint-disable-next-line class-methods-use-this
  completeCurrentStep(step) {
    step.classList.remove('is-active');
    step.classList.add('is-complete');
  }

  activateNextStep(step) {
    step.classList.add('is-active');

    this.scrollToTarget(step);
  }

  // eslint-disable-next-line class-methods-use-this
  clearSkippedStep(step) {
    step.classList.remove('is-complete');
    const answers = toArray(step.querySelectorAll('[data-target="guide.answer"]'));

    answers.forEach((answer) => {
      answer.checked = false;
    });
  }

  getChosenAnswers(formatted = false) {
    const answers = this.answerTargets
      .filter((answer) => answer.checked)
      .map((answer) => ({
        questionNumber: parseInt(answer.dataset.question, 10),
        question: answer.getAttribute('name'),
        answerNumber: parseInt(answer.value, 10),
      }));

    if (formatted) {
      const formattedAnswers = {};

      answers.forEach((answer) => {
        formattedAnswers[answer.question] = answer.answerNumber;
      });

      return formattedAnswers;
    }

    return answers;
  }

  fetchResults() {
    const answers = this.getChosenAnswers(true);

    $.ajax({
      type: 'POST',
      url: window.app.api.guide,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(answers),
      success: (res) => {
        const count = parseInt(res.count, 10);

        this.resultsCountTarget.innerText = `
          ${count} ${window.app.i18n[count === 1 ? 'result_found' : 'results_found']}
        `;

        this.resultsOutputTarget.innerHTML = res.results;
        this.resultsTarget.classList.add('is-visible');

        setTimeout(() => {
          this.scrollToTarget(this.resultsTarget);
        }, 1000);
      },
      error: ({ responseJSON }) => {
        if (!responseJSON) return;

        this.resultsTarget.classList.add('is-visible');
        this.resultsOutputTarget.innerHTML = '';
        this.resultsTitleTarget.innerText = responseJSON.message;
        this.resultsCountTarget.innerText = `0 ${window.app.i18n.results_found}`;
      },
    });
  }

  shootAnswersToAnalytics() {
    const answers = this.getChosenAnswers();

    const answersStringified = answers.map(({ questionNumber, answerNumber }) => (
      `${window.app.i18n.question}: ${questionNumber} ${window.app.i18n.answer}: ${answerNumber}`
    )).join();

    gtag.event('Keuzehulp', 'Alle vragen beantwoord', answersStringified);
  }

  scrollToTarget(target) {
    const $modal = $(this.modalTarget);
    const $target = $(target);

    $modal.animate({
      scrollTop: $target.offset().top - $modal.offset().top + $modal.scrollTop(),
    }, 'slow');
  }

  restartGuide() {
    this.answerTargets.forEach((answer) => {
      answer.checked = false;
    });

    $(this.modalTarget).animate({
      scrollTop: 0,
    }, 'slow');

    this.resultsTarget.classList.remove('is-visible');
    this.resultsOutputTarget.innerHTML = '';
  }

  openGuide() {
    gtag.event('Keuzehulp', `Geopend vanaf ${window.location.href}`, 'open');

    $(this.modalTarget).modal('show');
  }
}

GuideController.targets = [
  'modal',
  'step',
  'answer',
  'results',
  'resultsTitle',
  'resultsCount',
  'resultsOutput',
];

export default GuideController;
